export enum UserModuleUsage {
  AdminPage = 'AdminPage',
  CustomerDetailsPage = 'CustomerDetailsPage',
  UsersPage = 'UsersPage',
}
